<script setup>
import { ref, computed } from "vue";
import { useBookingStore } from "@stores/BookingStore";

const bookingStore = useBookingStore();

const randomVaccinations = computed(() => {
  const vaccinations = bookingStore.vaccinations;
  if (vaccinations && vaccinations.length >= 3) {
    for (let i = vaccinations.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [vaccinations[i], vaccinations[j]] = [vaccinations[j], vaccinations[i]];
    }
    return vaccinations.slice(0, 3);
  }
  return [];
});
</script>

<template>
  <article
    class="bg-white mb-40 px-20 py-25 border border-grey-border rounded-2xl font-medium list-syringe">
    <h4 class="mb-20 text-grey">Learn more about</h4>

    <ul class="text-15 list-check">
      <li
        v-for="vaccination in randomVaccinations"
        :key="vaccination.name"
        class="mb-10">
        <a
          class="text-blue"
          :href="vaccination.url"
          v-html="vaccination.name"
          target="_blank">
        </a>
      </li>
    </ul>
  </article>
</template>
